<template>
  <el-container>
    <el-aside style="width: 10.8vw">
      <el-menu class="sideMenu" :default-active="$route.path" @select="handleselect">
        <el-menu-item index="/dltg/zctg">代理推广</el-menu-item>
        <el-menu-item index="/dltg/yjlb">佣金列表</el-menu-item>
        <!-- <el-menu-item index="/dltg/kmlb">卡密列表</el-menu-item> -->
        <el-menu-item index="/dltg/txjl">提现记录</el-menu-item>
      </el-menu>
      <div class="fixed-bottom">重要通知<br><img :src="xtgg" class="xtgg_img" @click="xtgg_view()" /></div>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main><!-- 公告弹出框 -->
    <el-dialog
      :visible.sync="xtgg_dialogFormVisible"
      style="text-align: center; width: 100%; height: 120%; overflow-y: auto"
    >
      <el-form
        style="
          width: 100%;
          height: 100%;
          text-align: left;
        "
      >
        <el-form-item>
          <span style="font-weight:bold;font-size:24px">2025-09-02 网站升级更新 通知</span><br />
          <div style="background-color: #f7f8fb;padding-left: 20px;padding-right: 20px;    border-radius: 0.6em;">
            <span style="font-weight:bold;font-size:18px">网站升级更新 通知</span><br />
            <span style="font-size:16px">
              1.注册:手机号验证，可用于手机号修改 或发货人验证 <br />
              2.礼品网：不选择中转仓订单<br />
              3.订单查询，增加店铺分组<br />
              4.用户韵达同步上家单号绑定失败或其他异常，及时提示。韵达延迟15分钟后绑定失败自动退款并通知：订单编号：123456789，生成韵达单号321456987，因地址无法到达关联失败，请使用其他单号发送。已自动退款
            </span>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import xtgg from "../xtgg/index.vue";

export default {
  name: "dltg",
  components: {
    xtgg,
  },
  data() {
    return {
      wx_image: require("@/assets/kssh.png"),
      xtgg: require("@/assets/xtgg.jpg"),
      xtgg_dialogFormVisible:false,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    // const userToken = Cookies.get("view_userToken");

    // if (userToken == undefined) {
    //   this.isLogin = false;
    //   this.$confirm("请先登录再使用！", "提示", {
    //     confirmButtonText: "确定",
    //   })
    //     .then(() => {
    //       // 重新导航到登录页面
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/login" });
    //       return;
    //     })
    //     .catch(() => {
    //       // 重新导航到首页
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/" });
    //       return;
    //     });
    //   return;
    // } else {
    //   this.isLogin = true;
    // }
    if (this.$route.path == "/dltg") {
      this.handleselect("/dltg/zctg");
    }
  },
  methods: {
    handleselect(path) {
      this.$router.push(path);
    },
    xtgg_view(){
      this.xtgg_dialogFormVisible = true;
    }
  },
};
</script>

<style scoped>
.el-container {
  background-color: rgb(247, 248, 252);
  height: 90vh;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  display: none; /* 针对Chrome, Safari和Opera */
}
.el-side {
  width: 11vw;
  height: 90vh;
}
.el-main {
  height: 89vh;
  margin-top: 1.5vh;
  float: right;
  background-color: white;
  margin-left: 0.8vw;
  margin-right: 0.8vw;
}
.sidebar-nav {
  width: 10vw;
  height: 31vh;
  background-color: white;
  border-radius: 0.6em;
  margin-left: 0.8vw;
  margin-top: 1.5vh;
  text-align: left;
}
.sideMenu {
  text-align: left;
  width: 10vw;
  /* height: 31vh; */
  background-color: white;
  margin-left: 15px;
  margin-top: 1.5vh;
  font-weight: bold;
  border-radius: 0.6em;
}
.sideMenu .el-menu-item {
  color: rgb(110, 110, 110);
  border-radius: 0.6em;
  margin: 10px 15px;
  height: 42px;
  line-height: 42px;
}
/* .sidebar-nav ul {
    list-style-type: none;
    font-size: 14px;
    font-weight: bold;
    color: #838383;
    padding-top: 8px;
  }
  .sidebar-nav li {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 25px;
    margin: 10px 20px;
    border-radius: 0.5em;
    cursor: pointer;
  } */
.xtgg {
  background-color: #0850fc;
  width: 10vw;
  border-radius: 1.3em;
  height: 56vh;
  margin-left: 15px;
  margin-top: 1.5vh;
  text-align: left;
  padding: 6px;
  border: #525252 1px solid;
}
.xtgg_desc {
  background-color: white;
  border-radius: 1em;
  margin-top: 5px;
  margin-left: 2px;
  margin-right: 2px;
  height: 51vh;
  padding: 10px;
  font-weight: bold;
  color: rgb(110, 110, 110);
}
.wx_img {
  height: 60px;
  width: 60px;
}

/* //一定要添加！important提高优先级 */
.el-menu-item.is-active {
  /* //设置背景颜色 */
  background-color: #0850fc !important;
  /* //设置字体颜色 */
  color: white !important;
}
.xtgg_img {
  width: 80px;
}
.fixed-bottom {
  position: absolute; /* 或者使用 fixed，取决于是否需要跟随滚动 */
  bottom: 20px;
  color: red;
  font-size: 20px;
  left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/dltg/index.vue